import PrintTemplate from 'react-print'
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import DisplayDelivery from './DisplayDelivery'
import moment from 'moment'
import {formatPrice} from '../helpers/helpers'

class PrintSales extends Component{
    render() {
    	var select = this.props.selected
    	var range;
    	if(select=="All"){
    		 //from = "start";
    		 var to = moment().format("MMMM DD YYYY");
    		 range = ""
    	}
    	if(select=="Custom"){    		
    		range = (<p>from: {moment(this.props.fromDate).format("MMMM DD YYYY")} to:{moment(this.props.toDate).format("MMMM DD YYYY")} </p>)
    	}
    	if(select=="Daily"){
    		range = (<p>Date: {moment().format("MMMM DD YYYY")}  </p>)
    	}
    	if(select=="Weekly"){
    		var week = moment().week();
			range = (<p>from: {moment().isoWeek(week).startOf('isoweek').format("MMMM DD YYYY")} to: {moment().format("MMMM DD YYYY")} </p>)
    	}

    	if(select=="Monthly"){
    		var bulan = moment().format("MMMM")
			range = (<p>Month of {bulan} </p>)
    	}

        return (
            <PrintTemplate>
    			<div className="wrapThis"        	>
	            	<div className="salesReportWrapper">
	            		<div className="row topSaleHeader">
			            	<div className="printLogoArea pull-left">
			            		<img src="../../img/solapologo.jpg" />
			            	</div>

			            	<div id="poTop" className="contentReportSolapo pull-right">
								<h3>SOLAPO ROOFING CORPORATION</h3>
								<div className="row">
									<div className="col-1 pull-left">
										<p><strong>BACOLOD MAIN OFFICE:</strong></p>
										<p><span>3rd Road Burgos Ext.</span></p>
										<p><span>Brgy. Villamonte</span></p>
										<p><span>Bacolod City</span></p>
										<p><span>(034) 441-3860</span></p>
									</div>
									<div className="col-2 pull-left">
										<p><strong>CUSTOMER HOTLINE:</strong></p>
										<p><span>Smart: (0999) 994-6536</span></p>
										<p><span>Sun: (0932) 857-7356</span></p>
										<p><span>Globe (0917) 321-4945</span></p>
									</div>
									<div className="col-3 pull-left">
										<p><strong>EMAIL:</strong></p>
										<p><span>solaporoofingcenter@yahoo.com</span></p>
									</div>
								</div>
			            	</div>
			            	<div className="clearfix"></div>
		            	</div>
			            <h4 className="text-center"><strong>{select} Sales Reports</strong></h4>
			            <div className="salesRange text-center">{range}</div>
			            
			            <table id="normalLetterSpacing1" className="table tablePrint">
			                <thead className="theadSalesReport">
			                    <tr>               
			                        <th className="text-center printHeader salesTableDate">Quotation Number</th>
			                        <th className="text-center printHeader salesTableDate">Date</th>
			                        <th className="text-center printHeader salesTableDateName">Customer Name</th>
			                        <th className="text-center printHeader salesTableDateAddress">Customer Adress</th>
			                        <th className="text-center printHeader salesTableDateRep">Sales Representative</th>
			                        <th className="text-center printHeader forAmountSales">Amount</th>		                        
			                    </tr>
			                </thead>
			                <tbody>
			                    {
			                        this.props.data &&
			                            Object.keys(this.props.data).map(function (key){
			                                let list = this.props.data[key]
			                                return (<tr className="tableRowSales">
			                                			<td className="salesTableDate">
			                                				{list.quoteNumber}
			                                			</td>
			                                			<td className="salesTableDate">
			                                				{list.quoteDate}
			                                			</td>
			                                			<td className="salesTableDateName">
			                                				{list.customer.name}
			                                			</td>
			                                			<td className="salesTableDateAddress">
			                                				{list.customer.location}
			                                			</td>
			                                			<td className="salesTableDateRep">
			                                				{list.customer.representative}
			                                			</td>
			                                			<td className="forAmountSales">
			                                				{formatPrice(list.totalMaterials)}
			                                			</td>
			                                			
			                                		</tr>)
			                           }.bind(this))
			                    }
			                    <tr>
			                    	<td></td>
			                    	<td></td>
			                    	<td></td>
			                    	<td></td>
			                    	<td className="createBorderNoRight fontBoldOnly">Total Sales</td>
			                    	<td className="createBorderNoLeft fontBoldOnly">
				                    		{ 
						                        formatPrice(Object.keys(this.props.data)
						                            .reduce( function( sum, key){
						                            return sum + parseFloat( this.props.data[key].totalMaterials );                                                        
						                            }.bind(this), 0 )
						                        )

						                    }
			                    	</td>
			                    </tr>
			                </tbody>
			            </table>		            
		            </div>
		        </div>
			</PrintTemplate>
        );
    }
};

export default PrintSales;


// WEBPACK FOOTER //
// ./src/components/PrintSales.js